import { required } from '../helpers'
import { ValidationFunctions } from '../types'

export const text: ValidationFunctions = {
  _self: {
    required,
    regExp: (expression: string) => (value: string) => RegExp(expression).test(value),
  },
}
